import { PassportPageModel as Model } from './Model'


export const MODULE_NAME = 'passport_templates_routes'
export const MODULE_NAME_CACHES = 'passport-templates-cache'

export const PASSPORT_PAGES_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: PASSPORT_PAGES_ROUTES.LAYOUT,
  route: { name: PASSPORT_PAGES_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-passport',
} as const
